import React from "react";

export default function ProductsTableSkeleton() {
  // Crear un array de 5 elementos para simular filas de productos
  const skeletonRows = Array.from({ length: 5 }, (_, index) => index);

  return (
    <div className="bg-white rounded-xl shadow-sm overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full table-fixed">
          <thead className="bg-gray-50">
            <tr>
              <th scope="col" className="px-6 py-3 text-left text-sm font-medium text-gray-500 w-1/2">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </th>
              <th scope="col" className="px-6 py-3 text-left text-sm font-medium text-gray-500 w-1/4">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </th>
              <th scope="col" className="px-6 py-3 text-left text-sm font-medium text-gray-500 w-1/4">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </th>
              <th scope="col" className="px-6 py-3 text-left text-sm font-medium text-gray-500 w-1/4">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {skeletonRows.map((index) => (
              <tr key={index} className="hover:bg-gray-50">
                <td className="px-6 py-4 text-sm font-medium text-gray-900">
                  <div className="flex items-center gap-2">
                    {/* Skeleton para la imagen */}
                    <div className="w-10 h-10 bg-gray-200 rounded-md animate-pulse flex-shrink-0"></div>
                    {/* Skeleton para el nombre del producto */}
                    <div className="flex-1">
                      <div className="h-4 bg-gray-200 rounded animate-pulse mb-1"></div>
                      <div className="h-3 bg-gray-200 rounded animate-pulse w-3/4"></div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                  <div className="h-4 bg-gray-200 rounded animate-pulse w-20"></div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                  <div className="h-4 bg-gray-200 rounded animate-pulse w-24"></div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                  <div className="w-6 h-6 bg-gray-200 rounded animate-pulse"></div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
